import { render } from "./matchAvailability.vue?vue&type=template&id=36920032&scoped=true&ts=true"
import script from "./matchAvailability.vue?vue&type=script&lang=ts"
export * from "./matchAvailability.vue?vue&type=script&lang=ts"

import "./matchAvailability.vue?vue&type=style&index=0&id=36920032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36920032"]])

export default __exports__